import { api } from './api'
import to from 'await-to-js'

export default {
  async getActivity (context, hash) {
    const [error, response] = await to(api.getActivity(hash))

    if (response) {
      return Promise.resolve(response)
    }

    if (error) {
      return Promise.reject(error)
    }
  }
}
